module.exports = __webpack_public_path__ + "img/pen.9f8b6f35.svg";